import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface AllDeletedUsersData {
  id: number;
  userName: string | null;
  email: string | null;
  phoneNumber: string | null;
  azureToken: string | null;
  roleId: number | null;
  createdDate: string | null;
  updatedDate: string | null;
  status: boolean;
  otpGeneratedAt: string | null;
}

export interface GetDeletedUsersResponse {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  data: AllDeletedUsersData[];
}

export const GetAllDeletedUsersDataAsync = async (
  pageNumber: number,
  pageSize: number,
  token: string
): Promise<GetDeletedUsersResponse> => {
  const baseUrl = getApiBaseUrl();

  const apiUrl =
    `${baseUrl}/api/Admin/GetAllDeletedUsersDataAsync` +
    `?pageNumber=${pageNumber}&pageSize=${pageSize}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorMessage = await response.text();

      throw new Error(
        errorMessage ||
          `Failed to fetch deleted users. Status: ${response.status}`
      );
    }

    const result: GetDeletedUsersResponse = await response.json();
    return result;
  } catch (error) {
    console.error("Error in GetAllDeletedUsersDataAsync:", error);
    throw error;
  }
};